import React, { useState } from 'react';
import { Info } from 'lucide-react';

export interface InfoTooltipProps {
  text: string;
  position?: 'top' | 'bottom';
  align?: 'left' | 'right' | 'center';
  // Suppresses the card, e.g. while a column's header menu is open over it.
  disabled?: boolean;
}

const HORIZONTAL_CLASS = { left: 'left-0', right: 'right-0', center: 'left-1/2 -translate-x-1/2' } as const;

/** An (i) icon showing a dark help card on hover or keyboard focus. */
export const InfoTooltip: React.FC<InfoTooltipProps> = ({ text, position = 'top', align = 'center', disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const show = isOpen && !disabled;

  return (
    <span
      className={`relative inline-flex items-center ml-1 ${show ? 'z-[100]' : 'z-auto'}`}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button
        type="button"
        aria-label={text}
        onFocus={() => setIsOpen(true)}
        onBlur={() => setIsOpen(false)}
        onClick={(e) => e.stopPropagation()}
        className="inline-flex text-[#A1A1AA] hover:text-[#71717A] focus:outline-none focus-visible:text-[#71717A] cursor-help"
      >
        <Info className="w-3.5 h-3.5" />
      </button>
      {show && (
        <span
          role="tooltip"
          className={`pointer-events-none absolute ${position === 'bottom' ? 'top-full mt-2' : 'bottom-full mb-2'} ${HORIZONTAL_CLASS[align]} w-56 rounded-lg bg-[#18181B] px-3 py-2 text-left text-[12px] font-medium normal-case leading-[18px] text-white shadow-lg whitespace-normal break-words`}
        >
          {text}
        </span>
      )}
    </span>
  );
};

export default InfoTooltip;
